import appBasicsInit from 'AppBasicsInit'; // <- this should be on top of any other @lz imports
import LzXAppBootstrap from '@lz-app/Bootstrap';
import DashboardModule from 'modules/Dashboard';
import ParamsModule from 'modules/Params';
import ContentsModule from 'modules/Contents';
import ReportsModule from 'modules/Reports';
import SystemModule from 'modules/System';
import UserModule from 'modules/User';
import { defaultTheme } from 'themes';
import ImgLogo from './assets/images/logo.png';
import ImgBgBase from './assets/images/bg-base.jpg';
import ImgBgLogin from './assets/images/bg-login.jpg';

// Call this here so that app basics are initialized as early as possible.
// Also the import of `appBasicsInit` should be the very first in this file.
const temp = appBasicsInit;

export default function App() {
    return (
        <>
            <LzXAppBootstrap
                is_auth_based={true}
                auth_registeration_page={null}

                theme={defaultTheme}
                logo_image={ImgLogo}
                base_bg_image={ImgBgBase}
                login_bg_image={ImgBgLogin}

                modules={[DashboardModule, ParamsModule, ContentsModule, ReportsModule, SystemModule, UserModule]}
            />
        </>
    );
}
